"use client";
import * as React from 'react';
import { cn } from '@/lib/utils';

export interface FreeTitlebarProps {
  title: React.ReactNode;
  trafficLights?: boolean;
  left?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
  size?: 'compact' | 'large';
  centerMaxWidth?: number;
  center?: React.ReactNode;
}
export function FreeTitlebar({title,trafficLights=true,left,right,className,size='compact',centerMaxWidth=260,center}:FreeTitlebarProps){
  return <div data-slot="freeui-titlebar" data-size={size} className={cn('freeui-titlebar freeui-drag',className)} style={{'--freeui-titlebar-center-width':`${centerMaxWidth}px`} as React.CSSProperties}>
    <div className="freeui-titlebar-left freeui-no-drag">{left ?? (trafficLights && <span className="freeui-traffic-lights" aria-hidden="true"><i/><i/><i/></span>)}</div>
    <div className={cn('freeui-titlebar-center',center != null && 'freeui-no-drag')} aria-label={center != null && typeof title==='string'?title:undefined}>{center??title}</div>
    <div className="freeui-titlebar-right freeui-no-drag">{right}</div></div>;
}
export function FreeTitlebarWell({className,...props}:React.HTMLAttributes<HTMLDivElement>){return <div data-slot="freeui-titlebar-well" className={cn('freeui-titlebar-well',className)} {...props}/>;}
